// Mock data for SAX Project Management Services website
export const mockData = {
  company: {
    name: "SAX Project Management Services L.L.C",
    tagline: "Shaping Tomorrow with Smart Consulting & Project Solutions",
    description: "Your trusted partner in Technology, Mining, Finance & Project Management.",
    location: "Dubai – Al Baraha, BIN FARES 2, Office 101",
    phone: "+971553429293",
    whatsapp: "+971553429293",
    email: "info@saxpms.com",
    coordinates: { lat: 25.2682, lng: 55.3014 } // Dubai Al Baraha approximate
  },

  navigation: [
    { name: "Home", path: "/" },
    { name: "About", path: "/about" },
    { 
      name: "Services", 
      path: "/services",
      submenu: [
        { name: "Technology Consulting", path: "/services/technology" },
        { name: "Mining & Survey", path: "/services/mining" },
        { name: "Financial Consulting", path: "/services/financial" },
        { name: "Project Management", path: "/services/project-management" },
        { name: "Business Advisory", path: "/services/business-advisory" }
      ]
    },
    { name: "Projects", path: "/projects" },
    { name: "Team", path: "/team" },
    { name: "Why SAX", path: "/why-sax" },
    { name: "Request Service", path: "/request-service" },
    { name: "Contact", path: "/contact" }
  ],

  services: [
    {
      id: "technology",
      name: "Technology Consulting",
      description: "IT PMO, digital transformation, cybersecurity, data strategy, automation",
      benefits: [
        "Digital transformation roadmaps",
        "Cybersecurity assessments",
        "Data analytics implementation",
        "Process automation"
      ],
      process: ["Discovery & Assessment", "Strategy Development", "Implementation Planning", "Execution & Support"],
      kpis: [
        { label: "Digital Efficiency Increase", value: "40%" },
        { label: "Security Incidents Reduced", value: "85%" },
        { label: "Process Automation", value: "60%" }
      ]
    },
    {
      id: "mining",
      name: "Mining & Survey",
      description: "Geological & feasibility studies, site registration/compliance, equipment productivity analysis, EHS",
      benefits: [
        "Geological assessments",
        "Site compliance management",
        "Equipment optimization",
        "Safety protocol development"
      ],
      process: ["Site Evaluation", "Compliance Review", "Resource Analysis", "Optimization Plan"],
      kpis: [
        { label: "Safety Incidents Reduced", value: "75%" },
        { label: "Equipment Efficiency", value: "35%" },
        { label: "Compliance Rate", value: "98%" }
      ]
    },
    {
      id: "financial",
      name: "Financial Consulting",
      description: "Corporate planning, investment/risk analysis, valuation, reporting/feasibility studies",
      benefits: [
        "Financial planning & analysis",
        "Investment strategy",
        "Risk assessment",
        "Performance reporting"
      ],
      process: ["Financial Analysis", "Risk Assessment", "Strategy Development", "Implementation"],
      kpis: [
        { label: "Cost Savings Achieved", value: "25%" },
        { label: "ROI Improvement", value: "45%" },
        { label: "Risk Mitigation", value: "90%" }
      ]
    },
    {
      id: "project-management",
      name: "Project Management",
      description: "Planning/scheduling, cost/resource management, risk/mitigation, QA & performance monitoring",
      benefits: [
        "Project planning & scheduling",
        "Resource optimization",
        "Risk management",
        "Quality assurance"
      ],
      process: ["Project Initiation", "Planning & Scheduling", "Execution & Monitoring", "Delivery & Closure"],
      kpis: [
        { label: "On-Time Delivery", value: "95%" },
        { label: "Budget Adherence", value: "98%" },
        { label: "Client Satisfaction", value: "96%" }
      ]
    },
    {
      id: "business-advisory",
      name: "Business Advisory",
      description: "Operations optimization, regulatory/policy support, organizational development",
      benefits: [
        "Operational excellence",
        "Regulatory compliance",
        "Organizational development",
        "Strategic planning"
      ],
      process: ["Business Analysis", "Strategy Formulation", "Implementation Support", "Performance Review"],
      kpis: [
        { label: "Operational Efficiency", value: "30%" },
        { label: "Compliance Rate", value: "100%" },
        { label: "Growth Rate", value: "50%" }
      ]
    }
  ],

  values: [
    {
      title: "Integrity",
      description: "We uphold the highest standards of honesty and ethical conduct in all our dealings."
    },
    {
      title: "Innovation",
      description: "We embrace cutting-edge solutions and creative approaches to solve complex challenges."
    },
    {
      title: "Excellence",
      description: "We deliver superior results through meticulous attention to detail and quality."
    },
    {
      title: "Sustainability",
      description: "We create lasting value while considering environmental and social responsibility."
    }
  ],

  process: [
    {
      step: "01",
      title: "Discover",
      description: "We analyze your current situation, challenges, and objectives to understand your unique needs."
    },
    {
      step: "02", 
      title: "Design",
      description: "We develop tailored strategies and solutions aligned with your business goals and requirements."
    },
    {
      step: "03",
      title: "Deliver",
      description: "We execute the plan with precision, ensuring quality deliverables and measurable outcomes."
    },
    {
      step: "04",
      title: "Develop",
      description: "We provide continuous improvement and support for sustainable long-term success."
    }
  ],

  clients: [
    { name: "SAW Gold", logo: "https://via.placeholder.com/120x60/1F3C88/FFFFFF?text=SAW+Gold" },
    { name: "SAW Remit", logo: "https://via.placeholder.com/120x60/1F3C88/FFFFFF?text=SAW+Remit" },
    { name: "SAW Gold Precious Metals Test Laboratory LLC", logo: "https://via.placeholder.com/120x60/1F3C88/FFFFFF?text=SAW+Lab" },
    { name: "Global Trade Co.", logo: "https://via.placeholder.com/120x60/1F3C88/FFFFFF?text=Global+Trade" },
    { name: "Future Mining Ltd", logo: "https://via.placeholder.com/120x60/1F3C88/FFFFFF?text=Future+Mining" },
    { name: "TechBridge", logo: "https://via.placeholder.com/120x60/1F3C88/FFFFFF?text=TechBridge" },
    { name: "Prime Advisory", logo: "https://via.placeholder.com/120x60/1F3C88/FFFFFF?text=Prime+Advisory" }
  ],

  testimonials: [
    {
      name: "CEO, SAW Remit",
      company: "SAW Remit", 
      text: "SAX delivered outstanding project management expertise. They guided us through every stage with professionalism and precision.",
      rating: 5
    },
    {
      name: "Director, SAW Gold",
      company: "SAW Gold",
      text: "The mining consultation services provided by SAX were exceptional. Their expertise helped us optimize our operations significantly.",
      rating: 5
    },
    {
      name: "CFO, Global Trade Co.",
      company: "Global Trade Co.",
      text: "SAX's financial consulting transformed our business strategy. Their insights and recommendations exceeded our expectations.",
      rating: 5
    },
    {
      name: "CTO, TechBridge",
      company: "TechBridge", 
      text: "Outstanding technology consulting services. SAX helped us navigate our digital transformation with remarkable expertise.",
      rating: 5
    }
  ],

  stats: [
    { label: "Projects Completed", value: "200+" },
    { label: "Years of Experience", value: "10+" },
    { label: "Client Satisfaction", value: "99%" },
    { label: "Countries Served", value: "12+" }
  ],

  slogans: [
    "Shaping Tomorrow with Smart Consulting.",
    "Strategy. Execution. Results.",
    "Multi-Sector Expertise. Measurable Impact.",
    "From Vision to Verified Outcomes.",
    "Where Projects Become Performance.",
    "Trusted Consulting for Technology, Mining & Finance.",
    "Delivering Clarity, Control, and Growth.",
    "Your Partner in Precision and Performance.",
    "Insight-Led. Results-Driven.",
    "Complex Challenges, Simple Solutions.",
    "Plan with Confidence. Deliver with SAX.",
    "Engineered for Excellence.",
    "Smart Systems. Stronger Businesses.",
    "From Feasibility to Final Delivery.",
    "Consulting You Can Measure."
  ],

  ctaBanners: [
    "Let's build the next milestone together.",
    "Turn strategy into action—starting today.",
    "Speak with a sector expert now.",
    "Partner with SAX for excellence in consulting and project delivery."
  ]
};